export default "__VITE_ASSET__ByxFrqoE__"